/* The Fleece Company — fileiras arrastaveis e abas.
   overflow-x:auto so responde a toque/trackpad; no desktop com mouse
   o usuario clica-e-arrasta e nada acontece. Por isso o pointer handler. */
(function () {
  'use strict';

  function setupRow(row) {
    if (row.dataset.fcRow === '1') return;
    row.dataset.fcRow = '1';

    var track = row.querySelector('.fc-row__track');
    var prev = row.querySelector('.fc-row__nav--prev');
    var next = row.querySelector('.fc-row__nav--next');
    if (!track) return;

    function scrollable() { return track.scrollWidth - track.clientWidth > 4; }

    function sync() {
      var can = scrollable();
      [prev, next].forEach(function (b) { if (b) b.hidden = !can; });
      if (!can) return;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    function step() {
      var first = track.firstElementChild;
      var w = first ? first.getBoundingClientRect().width : 280;
      var gap = parseFloat(getComputedStyle(track).columnGap || '20') || 20;
      return Math.max(w + gap, track.clientWidth * 0.6);
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) { new ResizeObserver(sync).observe(track); }
    sync();
    setTimeout(sync, 400);

    // ---- arrasto com mouse ----
    var down = false, startX = 0, startScroll = 0, moved = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;             // toque ja funciona nativo
      if (e.target.closest('video, video-media')) return; // nao rouba o clique do player
      if (!scrollable()) return;
      down = true; moved = 0;
      startX = e.clientX; startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      track.scrollLeft = startScroll - dx;
      e.preventDefault();
    });

    function end(e) {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      sync();
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('pointerleave', end);

    // anti-clique: arrastar nao pode abrir o produto
    track.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function setupTabs(root) {
    if (root.dataset.fcTabs === '1') return;
    root.dataset.fcTabs = '1';
    var btns = root.querySelectorAll('.fc-tabs__btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-panel');
        btns.forEach(function (b) { b.setAttribute('aria-selected', String(b === btn)); });
        root.querySelectorAll('.fc-panel').forEach(function (p) {
          p.hidden = p.getAttribute('data-panel') !== target;
        });
        var vis = root.querySelector('.fc-panel:not([hidden]) .fc-row');
        if (vis) { vis.dataset.fcRow = ''; setupRow(vis); }
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.fc-row').forEach(setupRow);
    (scope || document).querySelectorAll('[data-fc-tabs]').forEach(setupTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  // editor de tema recarrega secoes sem recarregar a pagina
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---------------- scroll infinito na colecao ----------------
   O tema pagina com <a rel="next">. Aqui a proxima pagina e buscada,
   os cards sao anexados ao <product-list> e o link e atualizado.
   Se o fetch falhar, a paginacao volta a aparecer e nada se perde. */
(function () {
  'use strict';

  function proximaUrl(doc) {
    var a = (doc || document).querySelector('a[rel="next"]');
    return a ? a.getAttribute('href') : null;
  }

  function initInfinito() {
    var lista = document.querySelector('product-list');
    if (!lista || lista.dataset.fcInf === '1') return;
    var url = proximaUrl(document);
    if (!url) return;
    lista.dataset.fcInf = '1';

    var nav = document.querySelector('a[rel="next"]');
    nav = nav ? (nav.closest('nav') || nav.parentElement) : null;
    if (nav) nav.style.display = 'none';

    var sentinela = document.createElement('div');
    sentinela.className = 'fc-inf__sentinel';
    sentinela.innerHTML = '<span class="fc-inf__spinner" hidden>Loading…</span>';
    lista.parentNode.insertBefore(sentinela, lista.nextSibling);
    var spinner = sentinela.querySelector('.fc-inf__spinner');

    var carregando = false;

    function falhou() {
      if (nav) nav.style.display = '';
      sentinela.remove();
      if (obs) obs.disconnect();
    }

    function carregar() {
      if (carregando || !url) return;
      carregando = true;
      if (spinner) spinner.hidden = false;
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nova = doc.querySelector('product-list');
          if (!nova || !nova.children.length) { falhou(); return; }
          var frag = document.createDocumentFragment();
          while (nova.firstElementChild) { frag.appendChild(nova.firstElementChild); }
          lista.appendChild(frag);
          url = proximaUrl(doc);
          carregando = false;
          if (spinner) spinner.hidden = true;
          if (!url) { sentinela.remove(); if (obs) obs.disconnect(); }
        })
        .catch(function () { carregando = false; if (spinner) spinner.hidden = true; falhou(); });
    }

    var obs = null;
    if ('IntersectionObserver' in window) {
      obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) carregar(); });
      }, { rootMargin: '600px 0px' });
      obs.observe(sentinela);
    } else {
      window.addEventListener('scroll', function () {
        if (sentinela.getBoundingClientRect().top < innerHeight + 600) carregar();
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfinito);
  } else { initInfinito(); }
  document.addEventListener('shopify:section:load', function () { initInfinito(); });
})();
/* ---------------- rodape em acordeao no mobile ----------------
   Markup real: .footer__block--menu > p.bold + ul.v-stack
   Abaixo de 768px o titulo vira botao e a lista recolhe, como na fonte. */
(function () {
  'use strict';
  var MQ = window.matchMedia('(max-width: 767px)');

  function montar() {
    document.querySelectorAll('.footer__block--menu').forEach(function (bloco) {
      var titulo = bloco.querySelector('p, h2, h3, h4');
      var lista = bloco.querySelector('ul');
      if (!titulo || !lista) return;

      if (!MQ.matches) {                       // desktop: tudo aberto e sem botao
        bloco.classList.remove('fc-facc');
        lista.hidden = false;
        titulo.removeAttribute('role');
        titulo.removeAttribute('tabindex');
        titulo.setAttribute('aria-expanded', 'true');
        return;
      }

      bloco.classList.add('fc-facc');
      if (bloco.dataset.fcFacc !== '1') {
        bloco.dataset.fcFacc = '1';
        titulo.setAttribute('role', 'button');
        titulo.setAttribute('tabindex', '0');
        titulo.setAttribute('aria-expanded', 'false');
        function alterna() {
          var aberto = titulo.getAttribute('aria-expanded') === 'true';
          titulo.setAttribute('aria-expanded', String(!aberto));
          lista.hidden = aberto;
        }
        titulo.addEventListener('click', alterna);
        titulo.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); alterna(); }
        });
      }
      lista.hidden = titulo.getAttribute('aria-expanded') !== 'true';
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', montar); }
  else { montar(); }
  if (MQ.addEventListener) { MQ.addEventListener('change', montar); }
  document.addEventListener('shopify:section:load', montar);
})();
/* ---------------- carrinho: relogio de reserva + selos ----------------
   O bloco de selos e renderizado no topo (unico slot de custom liquid do tema)
   e movido pro rodape do drawer, ao lado do botao de checkout. */
(function () {
  'use strict';
  var CHAVE = 'fc:cart-reserve';
  var DURACAO = 5 * 60 * 1000;

  function inicio() {
    var t = 0;
    try { t = parseInt(sessionStorage.getItem(CHAVE) || '0', 10); } catch (e) {}
    if (!t || Date.now() - t > DURACAO) {
      t = Date.now();
      try { sessionStorage.setItem(CHAVE, String(t)); } catch (e) {}
    }
    return t;
  }

  function tick() {
    var el = document.querySelector('[data-fc-clock]');
    if (!el) return;
    var resta = Math.max(0, DURACAO - (Date.now() - inicio()));
    var m = Math.floor(resta / 60000), s = Math.floor((resta % 60000) / 1000);
    el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    var barra = document.querySelector('[data-fc-reserve]');
    if (barra) barra.hidden = document.querySelector('cart-count') && document.querySelector('cart-count').textContent.trim() === '0';
  }

  function moverSelos() {
    var selos = document.querySelector('[data-fc-cart-foot]');
    if (!selos || selos.dataset.fcMoved === '1') return;
    var btn = document.querySelector('.cart-drawer a[href*="/checkout"], .cart-drawer button[name="checkout"], [class*="cart"] [name="checkout"]');
    var alvo = btn ? (btn.closest('form') || btn.parentElement) : null;
    if (!alvo) return;
    alvo.appendChild(selos);
    selos.hidden = false;
    selos.dataset.fcMoved = '1';
  }

  function init() { tick(); moverSelos(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  setInterval(function () { tick(); moverSelos(); }, 1000);
  document.addEventListener('cart:refresh', init);
  document.addEventListener('shopify:section:load', init);
})();
/* ---------------- 2 produtos no fim do menu lateral ----------------
   A fonte mostra dois cards no rodape do drawer. O tema nao tem slot pra isso,
   entao os dados vem do endpoint .js do produto e o card usa as classes
   .fc-card que ja existem no fc.css. Se algum fetch falhar, nada e inserido. */
(function () {
  'use strict';
  var HANDLES = ['blanket', 'cryocomfort-cooling-blanket', 'the-muslin-blanket'];

  function money(centavos) { return '$' + (centavos / 100).toFixed(2); }

  function card(p) {
    var v = p.variants && p.variants[0];
    if (!v) return '';
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) { img = 'https:' + img; }
    var de = (v.compare_at_price && v.compare_at_price > v.price)
      ? '<del>' + money(v.compare_at_price) + '</del>' : '';
    return '<a class="fc-card fc-drawer-promo__card" href="/products/' + p.handle + '">' +
      '<span class="fc-card__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="fc-card__title">' + p.title + '</span>' +
      '<span class="fc-card__price">' + de + '<span>' + money(v.price) + '</span></span>' +
      '</a>';
  }

  function montar() {
    var scroller = document.querySelector('.navigation-drawer .panel__scroller');
    if (!scroller || scroller.dataset.fcPromo === '1') { return; }
    scroller.dataset.fcPromo = '1';

    var pedidos = HANDLES.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(pedidos).then(function (lista) {
      var bons = lista.filter(Boolean).slice(0, 2);
      if (bons.length < 2) { scroller.dataset.fcPromo = ''; return; }
      var wrap = document.createElement('div');
      wrap.className = 'fc-drawer-promo';
      wrap.innerHTML = bons.map(card).join('');
      scroller.appendChild(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else { montar(); }
  document.addEventListener('shopify:section:load', montar);
})();
